import { render, staticRenderFns } from "./ConversationMessagePane.vue?vue&type=template&id=b9f4ff46"
import script from "./ConversationMessagePane.vue?vue&type=script&lang=js"
export * from "./ConversationMessagePane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports